import React, { useRef, useState } from "react";

enum TooltipDirection {
    top = "top",
    left = "left",
    right = "right"
}

type direction = "top" | "left" | "right" | "bottom" | "bottom-right" | "bottom-left"
type size = "lg" | "sm" | "md"

interface ITooltipProps {
    children: React.ReactNode,
    direction?: direction,
    title: string,
    size?: size,
    tooltipShowTimeout?: number
}

const getStylesByDirection = (direction: direction) => {
    switch(direction) {
        case "top": {
            return 'bottom-full left-1/2 transform -translate-x-1/2';
        }
        break;
        case "bottom": {
            return 'top-full left-1/2 transform -translate-x-1/2';
        }
        break;
        case "left": {
            return 'right-full top-1/2 transform -translate-y-1/2';
        }
        break;
        case "right": {
            return 'left-full top-1/2 transform -translate-y-1/2';
        }
        break;
        case "bottom-right": {
            return 'top-full right-0 transform';
        }
        break;
        case "bottom-left": {
            return 'top-full left-0 transform';
        }
        break;
    }
}

const sizeClasses = (size: "lg" | "sm" | "md" | undefined) => {
    switch (size) {
        case 'lg':
            return 'min-w-72 p-3';
        case 'md':
            return 'min-w-60 p-2';
        case 'sm':
            return 'min-w-44 p-2';
        default:
            return 'p-2';
    }
};

const Tooltip: React.FC<ITooltipProps> = ({
    children,
    direction = "top",
    size,
    title,
    tooltipShowTimeout = 400
}) => {
    const [showing, setShowing] = useState<boolean>(false);

    let timeout: ReturnType<typeof setTimeout>;

    const onMouseEnterHandler = () => {
        showTooltipHandler();
    }

    const onMouseLeaveHandler = () => {
        hideTooltipHandler();
    }

    const showTooltipHandler = () => {
        timeout = setTimeout(() => {
            setShowing(true)
        }, tooltipShowTimeout)
    }

    const hideTooltipHandler = () => {
        clearTimeout(timeout);
        setShowing(false);
    }

    return (
        <div
            onMouseEnter={onMouseEnterHandler}
            onMouseLeave={onMouseLeaveHandler}
            className='relative'
        >
            {children}
            {showing &&
                <div
                    className={`rounded bg-c-light-gray dark:bg-c-light-black border border-c-gray dark:border-c-gray text-gray-800 dark:text-white shadow-lg absolute z-60 ${sizeClasses(size)} ${getStylesByDirection(direction)}`}
                >
                    <div>
                        <span className="normal-case font-semibold">{title}</span>
                    </div>
                </div>
            }
        </div>
    )
}

export default Tooltip;